var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ri:bill-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.3333 25.6666H4.66667C4.35725 25.6666 4.0605 25.5437 3.84171 25.3249C3.62292 25.1061 3.5 24.8093 3.5 24.4999V3.49992C3.5 3.1905 3.62292 2.89375 3.84171 2.67496C4.0605 2.45617 4.35725 2.33325 4.66667 2.33325H23.3333C23.6428 2.33325 23.9395 2.45617 24.1583 2.67496C24.3771 2.89375 24.5 3.1905 24.5 3.49992V24.4999C24.5 24.8093 24.3771 25.1061 24.1583 25.3249C23.9395 25.5437 23.6428 25.6666 23.3333 25.6666ZM9.33333 10.4999V12.8333H18.6667V10.4999H9.33333ZM9.33333 15.1666V17.4999H18.6667V15.1666H9.33333Z",
    fill: "#D3AB2A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillIcon);
export default __webpack_public_path__ + "static/media/bill_icon.55e507ac5428ac71c92f14865d961b9e.svg";
export { ForwardRef as ReactComponent };